import React, { useEffect, useState } from "react";
import ModalComponent from "../../components/ModalComponent";
import { required } from "redux-form-validators";
import TextField from "@material-ui/core/TextField";

import { Field, reduxForm, reset } from "redux-form";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import Button from "../../components/Button";
import Popover from "../../components/Popover";
import CustomizedInputs from "../../components/UIform";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import CircularProgress from "@material-ui/core/CircularProgress";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import { useTranslation } from "react-i18next";

const CreateIngredients = ({
	onClose,
	open,
	createIngredients,
	initialData,
	isEdit,
	updateIngredient,
	selectId,
}) => {
	const classes = useStyles();

	const { t } = useTranslation();

	const [nameRu, setNameRu] = useState("");
	const [nameUa, setNameUa] = useState("");
	const [nameEn, setNameEn] = useState("");
	const [idCategories, setIdCategories] = useState([]);
	const [errors, setErrors] = useState({
		nameRu: false,
		nameUa: false,
		nameEn: false,
	});

	const [noIndgForCategoriesIds, setNoIndgForCategoriesIds] = useState([]);

	useEffect(() => {
		if (initialData) {
			setNameRu(initialData.name.ru);
			setNameUa(initialData.name.uk);
			setNameEn(initialData.name.en);
			setNoIndgForCategoriesIds(initialData.productsIds || [""]);
		}
	}, [initialData]);

	const handleInputChange = (setter) => (event) => {
		const { name, value } = event.target;

		setter(value);

		setErrors((prev) => ({
			...prev,
			[name]: false, // Используем сохранённое имя
		}));
	};

	const handleAddCategory = () => {
		const status = noIndgForCategoriesIds.find((chip) => chip === idCategories);
		const isValue = idCategories.length > 0 ? true : false;

		if (status === undefined && isValue) {
			setNoIndgForCategoriesIds([...noIndgForCategoriesIds, idCategories]);
			setIdCategories("");
		} else if (!isValue) {
			alert("Пустое поле");
		} else {
			alert("Данный ID уже есть в списке");
		}
	};

	const handleDeleteCategory = (categoryId) => {
		setNoIndgForCategoriesIds((prevState) =>
			prevState.filter((id) => id !== categoryId)
		);
	};

	const submitForm = async (data) => {
		if (isEdit) {
			await updateIngredient(selectId, data);
		} else {
			await createIngredients(data);
		}

		console.log("Форма отправлена с данными:", data);
		// Добавь логику для отправки данных формы
	};

	const handleSubmit = (event) => {
		event.preventDefault();

		const newErrors = {
			nameRu: !nameRu.trim(),
			nameUa: !nameUa.trim(),
			nameEn: !nameEn.trim(),
		};

		setErrors(newErrors);
		if (!Object.values(newErrors).includes(true)) {
			submitForm({ nameRu, nameUa, nameEn, noIndgForCategoriesIds });
			handleClose();
		}
	};

	const handleClose = () => {
		setNameRu("");
		setNameUa("");
		setNameEn("");
		setIdCategories("");
		setNoIndgForCategoriesIds([]);
		setErrors({
			nameRu: false,
			nameUa: false,
			nameEn: false,
		});
		onClose();
	};

	return (
		<Modal open={open} onClose={handleClose}>
			<Box className={classes.modal}>
				<CloseIcon
					onClick={() => handleClose()}
					className={classes.closeIcon}
				/>

				<form onSubmit={handleSubmit} autoComplete="off">
					<div className={classes.title}>Названия ингредиентов</div>
					<div className={classes.formGroup}>
						<TextField
							label="Название (Русский)"
							placeholder="Введите название на русском"
							name="nameRu"
							type="text"
							onChange={handleInputChange(setNameRu)}
							value={nameRu}
							error={errors.nameRu}
							helperText={errors.nameRu ? "Это поле обязательно" : ""}
						/>
						<TextField
							label="Название (Украинский)"
							placeholder="Введите название на украинском"
							name="nameUa"
							type="text"
							onChange={handleInputChange(setNameUa)}
							value={nameUa}
							error={errors.nameUa}
							helperText={errors.nameUa ? "Это поле обязательно" : ""}
						/>
						<TextField
							label="Название (Английский)"
							placeholder="Введите название на английском"
							name="nameEn"
							type="text"
							onChange={handleInputChange(setNameEn)}
							value={nameEn}
							error={errors.nameEn}
							helperText={errors.nameEn ? "Это поле обязательно" : ""}
						/>
					</div>

					{/* Блок добавления категорий */}
					<div className={classes.categoriesWrap}>
						<div className={classes.headerWrapper}>
							<Typography className={classes.typography}>
								id ингредиентов товаров
							</Typography>
							<Popover className={classes.popover} title="" hiddenTitle="-" />
						</div>
						<div className={classes.chips}>
							<ul className={classes.chipsList}>
								{noIndgForCategoriesIds?.map((data, index) => (
									<li key={index} className={classes.chipsListLi}>
										<Chip
											label={data}
											onDelete={() => handleDeleteCategory(data)}
											className={classes.chip}
										/>
									</li>
								))}
							</ul>
						</div>
						<div className={classes.wrapper}>
							<TextField
								placeholder="Введите ID товара"
								value={idCategories}
								onChange={handleInputChange(setIdCategories)}
								className={classes.inputField}
							/>
							<Button
								className={classes.button}
								text={t("buttons.addList")}
								handleClick={handleAddCategory}
							/>
						</div>
					</div>

					{/* Отправка формы */}
					<Button
						className={classes.submitButton}
						text={`${isEdit ? "изменить" : "сохранить"}`}
						handleClick={handleSubmit}
						type="button"
					/>
				</form>
			</Box>
		</Modal>
	);
};

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: "10px",
		fontSize: "18px",
	},
	closeIcon: {
		marginRight: 16,
		color: "#476282",
		position: "absolute",
		right: "16px",
		top: "16px",
		"&:hover": {
			color: "black",
			cursor: "pointer",
		},
	},
	formGroup: {
		display: "flex",
		flexDirection: "column",
		gap: "16px",
		padding: "16px",
		background: "#f9f9f9",
		borderRadius: "8px",
		boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
	},
	modal: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: 800,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(4),
		display: "flex",
		flexDirection: "column",
		gap: theme.spacing(2),
		maxHeight: "90vh",
		overflow: "auto",
		[theme.breakpoints.down("sm")]: {
			// Медиа-запрос для экранов меньше small (600px)
			width: "90%", // Устанавливаем максимальную ширину для маленьких экранов
			top: 0,
			left: 0,
			right: 0,
			transform: "translate(0, 0)",
			padding: "16px",
		},
	},
	modalButton: {
		marginTop: theme.spacing(2),
	},
	formControl: {
		width: "100%",
	},
	dialogPaper: {
		width: "80%",
		maxWidth: 1057,
		padding: 24,
	},
	dialogTitle: {
		padding: 0,
		"& h2": {
			fontSize: 16,
			fontWeight: "normal",
			lineHeight: "25px",
		},
	},
	iconsWrapper: {
		display: "flex",
	},
	// closeIcon: {
	// 	marginRight: 16,
	// 	color: "#476282",
	// 	"&:hover": {
	// 		color: "black",
	// 		cursor: "pointer",
	// 	},
	// },
	buttonWrapper: {
		margin: "0 auto",
		marginTop: 30,
		textAlign: "center",
	},
	discountRadios: {
		marginTop: 30,
		[theme.breakpoints.down("600")]: {
			marginTop: 16,
		},
	},
	discountInput: {
		display: "flex",
		flexDirection: "column",
		height: 57,
		width: "100%",
		padding: "0 16px 16px 16px",
		marginBottom: 16,
		boxSizing: "border-box",

		boxShadow: "0px 14px 23px rgba(232, 228, 228, 0.5)",
		background: "white",
		borderRadius: 5,
	},
	discountTitle: {
		fontSize: 16,
		fontWeight: 500,
		lineHeight: "57px",
		color: "black",
	},
	discountInputWrap: {
		width: "100%",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		cursor: "pointer",
	},
	discountRadio: {
		margin: 0,
		cursor: "pointer",
	},
	discountHidden: {
		width: 328,
		[theme.breakpoints.down("600")]: {
			width: "100%",
		},
	},
	otherFields: {},
	code: {},
	otherInput: {
		width: "100%",
		marginTop: 8,
		"& input": {
			width: "100%",
			height: 45,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 50px 11px 16px",
			boxSizing: "border-box",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			content: "none",
		},
		"& .MuiInput-underline:after": {
			content: "none",
		},
		"& .MuiInput-underline:before": {
			content: "none",
		},
		"& .Mui-error input": {
			border: "1px solid red",
		},
	},
	textarea: {
		maxWidth: "327px",
		width: "100%",
		[theme.breakpoints.down("600")]: {
			maxWidth: "100%",
		},
		"& > div:before": {
			display: "none",
		},
		"& > div": {
			// width: '327px',
			marginTop: 8,
			resize: "none",
			// height: 103,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 16px 11px 16px",
			boxSizing: "border-box",
			fontSize: 16,
			fontFamily: "Roboto, Helvetica, Arial, sans-serif",
			lineHeight: "24px",
			[theme.breakpoints.down("600")]: {
				width: "100%",
			},
		},
		"& > div:after": {
			display: "none",
		},
		"& > div.Mui-error": {
			border: "1px solid red;",
		},
		"&::-webkit-input-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea:-moz-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea::-moz-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea:-ms-input-placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
		"&::textarea::placeholder": {
			color: "#DADCE0",
			fontWeight: 400,
		},
	},
	otherInputDescription: {
		width: "100%",
		marginTop: 8,
		"& input": {
			width: "100%",
			height: 103,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 50px 11px 16px",
			boxSizing: "border-box",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			content: "none",
		},
		"& .MuiInput-underline:after": {
			content: "none",
		},
		"& .MuiInput-underline:before": {
			content: "none",
		},
		"& .Mui-error input": {
			border: "1px solid red",
		},
	},
	checkbox: {
		"&.MuiCheckbox-colorPrimary.Mui-checked": {
			color: "#326dff",
		},
		"&.MuiCheckbox-colorPrimary": {
			padding: 10,
		},
	},
	headerWrapper: {
		display: "flex",
		position: "relative",
		maxWidth: 438,
	},
	popover: {
		top: 2,
	},
	categoriesWrap: {
		marginTop: 24,
		padding: 16,
		minHeight: 132,

		border: "1px solid #DADCE0",
		boxSizing: "border-box",
		borderRadius: 5,
		background: "white",
	},
	typography: {
		fontSize: 18,
		fontWeight: 500,
		lineHeight: "21px",
		paddingRight: 20,
	},
	wrapper: {
		display: "flex",
		alignItems: "end",
		[theme.breakpoints.down("600")]: {
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
		},
	},
	categoriesContent: {
		display: "flex",
		[theme.breakpoints.down("600")]: {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
		},
	},
	inputField: {
		"& input": {
			width: 328,
			height: 45,
			border: "1px solid #DADCE0",
			borderRadius: "5px",
			padding: "11px 50px 11px 16px",
			boxSizing: "border-box",
		},
		"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
			content: "none",
		},
		"& .MuiInput-underline:after": {
			content: "none",
		},
		"& .MuiInput-underline:before": {
			content: "none",
		},
		"& .Mui-error input": {
			border: "1px solid red",
		},
		[theme.breakpoints.down("375")]: {
			"& > div > input": {
				width: "100%",
			},
		},
	},
	button: {
		marginTop: 0,
		marginLeft: 15,
		fontSize: 14,
		textTransform: "inherit",
		[theme.breakpoints.down("600")]: {
			marginTop: 16,
			marginLeft: 0,
		},
	},

	chipsList: {
		paddingLeft: 0,
		display: "flex",
		flexWrap: "wrap",
		[theme.breakpoints.down("600")]: {
			width: "100%",
			display: "flex",
			flexDirection: "column",
			"& > li > div": {
				width: "100%",
			},
			"& > li:last-child > hr": {
				display: "none",
			},
		},
	},
	chipsListLi: {
		listStyleType: "none",
		marginRight: 5,
		marginBottom: 5,
		[theme.breakpoints.down("600")]: {
			marginRight: 5,
		},
	},
	chip: {
		fontSize: 12,
		lineHeight: 1,
		color: "white",
		backgroundColor: "#326DFF",
		[theme.breakpoints.down("600")]: {
			display: "flex",
			justifyContent: "space-between",
			background: "#E0E9FF",
			color: "#326DFF",
			padding: "0 6px",
		},

		"&.MuiChip-deletable > .MuiChip-deleteIcon": {
			color: "rgba(255, 255, 255, .26)",
			[theme.breakpoints.down("600")]: {
				color: "rgba(255, 255, 255, 1)",
			},
		},
	},
	hr: {
		border: "1px dashed rgba(71, 98, 130, .25)",
		boxSizing: "border-box",
		marginLeft: "10px",
		marginRight: "10px",
	},
}));

export default CreateIngredients;
